import React from 'react';
import { Link } from 'react-router-dom';
import { PencilIcon, TrashIcon, CalendarIcon, ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { downloadSetlistDocx } from '../utils/setlistDocx';

const SetListsTable = ({ setlists, songs = [], onEdit, onDelete }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getSongById = (songId) => {
    return songs.find(song => song.id === songId);
  };

  const getTotalDuration = (setlist) => {
    let totalSeconds = 0;
    setlist.sets?.forEach(set => {
      set.items?.forEach(item => {
        if (item.type === 'banter' && item.banter?.duration) {
          totalSeconds += item.banter.duration;
        } else if (item.type === 'song' && item.song_id) {
          const song = getSongById(item.song_id);
          if (song && song.duration) {
            totalSeconds += song.duration;
          }
        }
      });
    });
    
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  const getSongCount = (setlist) => {
    let songCount = 0;
    setlist.sets?.forEach(set => {
      set.items?.forEach(item => {
        if (item.type === 'song' && item.song_id) {
          songCount++;
        }
      });
    });
    return songCount;
  };

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <table className="min-w-full">
        <thead className="bg-blue-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Name
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Date
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Sets
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Songs
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Duration
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {setlists.map((setlist, index) => (
            <tr key={setlist.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <CalendarIcon className="w-5 h-5 text-gray-400 mr-3" />
                  <Link
                    to={`/setlists/${setlist.id}`}
                    className="text-sm font-medium text-blue-600 hover:text-blue-800 hover:underline"
                  >
                    {setlist.name}
                  </Link>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {formatDate(setlist.date)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {setlist.sets?.length || 0}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {getSongCount(setlist)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {getTotalDuration(setlist)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
                <button
                  onClick={() => onEdit(setlist)}
                  className="text-blue-600 hover:text-blue-900"
                  title="Edit"
                >
                  <PencilIcon className="w-4 h-4" />
                </button>
                <button
                  onClick={() => downloadSetlistDocx(setlist, songs)}
                  className="text-green-600 hover:text-green-900"
                  title="Download"
                >
                  <ArrowDownTrayIcon className="w-4 h-4" />
                </button>
                <button
                  onClick={() => onDelete(setlist.id)}
                  className="text-red-600 hover:text-red-900"
                  title="Delete"
                >
                  <TrashIcon className="w-4 h-4" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      {setlists.length === 0 && (
        <div className="text-center py-8 text-gray-500">
          No set lists found. Create your first set list!
        </div>
      )}
    </div>
  );
};

export default SetListsTable;